<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body" ></p-confirmDialog>
<app-cc-form-dialog #batchUpdateFormDialog [transPartKey]="transPartKey"
                    [loading]="formLoading" [submitted]="formSubmitted"
                    [(dialogFormVisible)]="dialogFormVisible"
                    (dialogFormVisibleChange)="dialogFormVisibleChanged($event)"
                    [formConfig]="formConfig" [dialogFormTitle]="dialogFormTitle"
                    [(formRecord)]="formRecord" (onSubmitEvent)="save()"
                    [submitButtonLabel]="'common.table.batch_update_button'|translate"
                    [loadingProgressValue]="settingsFormLoadingProgressValue"
></app-cc-form-dialog>

